import nanoid from "nanoid";

export const getUniqueFileName = (fileName: string): string => {
    const fileNames = fileName.split('.');
    let fileExt = '';
    if ( fileNames.length > 1 ) {
        fileExt = '.' + fileNames[fileNames.length - 1];
    }
    return nanoid(16) + fileExt;
}